import { useTranslation } from 'react-i18next';
import { Filter } from 'lucide-react';

interface GroupByToggleProps {
  groupBy: 'Invoice' | 'Item';
  onChange: (value: 'Invoice' | 'Item') => void;
}

export default function GroupByToggle({ groupBy, onChange }: GroupByToggleProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-1.5 flex-1 min-w-[150px]">
      <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <Filter className="w-4 h-4 text-gray-400" />
        {t('reports.groupBy')}
      </label>
      <div className="flex p-1 bg-gray-100 rounded-lg">
        <button
          type="button"
          className={`flex-1 px-3 py-1.5 text-sm font-medium rounded-md transition-all ${
            groupBy === 'Invoice' ? 'bg-white text-primary-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'
          }`}
          onClick={() => onChange('Invoice')}
        >
          {t('reports.invoice')}
        </button>
        <button
          type="button"
          className={`flex-1 px-3 py-1.5 text-sm font-medium rounded-md transition-all ${
            groupBy === 'Item' ? 'bg-white text-primary-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'
          }`}
          onClick={() => onChange('Item')}
        >
          {t('reports.item')}
        </button>
      </div>
    </div>
  );
}
